import React, { FC, ReactNode, useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
// import TickIcon from "../../../../../images/common/green-tick-italic.svg";
import CopyIcon from "../../../../../images/checkout/copyicon-blue.svg";
import ShareIcon from "../../../../../images/checkout/shareicon-blue.svg";
import LinkIcon from "../../../../../images/common/link-blue.svg";
import qrCodeIcon from "../../../../../images/products/qr-code-image-blue.svg";
import ActiveLinkIcon from "../../../../../images/sidebar/link-royal-blue.svg";
import ActiveQRCode from "../../../../../images/products/qr-code-image.svg";
import styled from "styled-components";
import { saveAs } from "file-saver";
import { Canvg } from "canvg";
import {
  CustomLabel,
  FlexContainer,
  IOption,
  IStyleProps,
  SingleSelect,
  ToastService,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import DownloadIcon from "../../../../../images/common/download-blue.svg";
// import DesignIcon from "../../../../../images/common/design-qr-blue.svg";
//please apply this icon as well

const sharingOptions = [
  {
    icon: LinkIcon,
    label: "Link",
    activeIcon: ActiveLinkIcon,
  },
  {
    icon: qrCodeIcon,
    label: "QR Code",
    activeIcon: ActiveQRCode,
  },
];

const sizeOptions: IOption[] = [
  { label: "512 x 512", value: "512" },
  { label: "1024 x 1024", value: "1024" },
  { label: "2048 x 2048", value: "2048" },
  { label: "4096 x 4096", value: "4096" },
];

const errorCorrectionOptions: IOption[] = [
  { label: "Low", value: "L" },
  { label: "Medium", value: "M" },
  { label: "High", value: "Q" },
  { label: "Highest", value: "H" },
];

const fileTypeOptions: IOption[] = [
  { label: "PNG", value: "png" },
  // { label: "SVG", value: "svg" },
  { label: "JPG", value: "jpg" },
  // { label: "PDF", value: "pdf" },
];

const QRCustomWrapper = styled.div`
  display: flex;
  align-items: center;
  .download-qr-icon {
    height: 20px;
    width: 18px;
    cursor: pointer;
  }
  .single-select-wrapper.qr-dpdn {
    width: auto;
    min-width: 50px;
    font-size: 14px;
    .header {
      width: auto;
      min-width: 50px;
      padding-right: 35px;
      height: 30px;
      padding: 3px;
      padding-right: 30px;
      border: 1px solid #ccc;
    }
    .select-header-icon {
      height: unset;
      font-size: 17px;
      font-size: 17px;
      top: 50%;
      transform: translateY(-50%);
      .fa-caret-down {
        font-size: 17px;
        color: #666;
      }
    }
    .options-menu {
      transform: translate(0px, 35px);
      min-width: 120px;
      font-size: 14px;
      width: auto;
      padding: 0px;
      border-radius: 4px;
      li {
        font-size: 14px;
        padding: 0px 10px;
      }
    }
  }
  .qr-labels {
    font-size: 15px;
    /* color: #555; */
  }
`;
const SharingOptions = styled.div<IStyleProps>`
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 3px solid
    ${(props) => (props.active ? "rgba(85, 107, 184, 0.5)" : "transparent")};
  cursor: pointer;
  img {
    width: 22px;
    height: 20px;
  }
  label {
    color: ${(props) => (props.active ? "#556bb8" : "#555")};
    cursor: pointer;
  }
`;
const QRWrapper = styled.div`
  padding: 10px;
  background: #fff;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 5px;
`;
const SettingsPanel = styled.div`
  background: white;
  padding: 10px 13px;
  margin-top: 18px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 320px;
  position: absolute;
  top: 0px;
  left: 0px;
  /* transform: translate(36px, -72px); // to open on right */
  transform: translate(-140px, 21px); // to show on bottom
  &::before {
    position: absolute;
    /* top: -26px;
    left: unset;
    right: 53px; */
    display: inline-block;
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgb(221, 221, 221);
    border-left: 10px solid transparent;
    content: "";
    padding-top: 15px;
    top: 0;
    left: 50%;
    right: unset;
    transform: translate(-21px, -26px);
  }
  &::after {
    position: absolute;
    /* top: -9px;
    left: unset;
    right: 53px; */
    display: inline-block;
    border-right: 10px solid transparent;
    border-bottom: 10px solid rgb(255, 255, 255);
    border-left: 10px solid transparent;
    content: "";
    top: 0;
    left: 50%;
    right: unset;
    transform: translate(-21px, -10px);
  }
`;
const DownloadButton = styled.button`
  background-color: #57ac2d;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  max-width: 200px;
  margin: 0 auto;
  &:hover {
    background-color: #57ac2d;
  }
`;

interface SharingSectionProps {
  id: string;
  name: string;
  isCheckout?: boolean;
  purchaseURL: string;
}

const SharingSection: FC<SharingSectionProps> = ({
  purchaseURL,
  id,
  isCheckout,
}) => {
  const [selectedTab, setSelectedTab] = useState("Link");
  const [size, setSize] = useState(512);
  const [errorCorrection, setErrorCorrection] = useState("H");
  const [fileType, setFileType] = useState("png");
  const [showSettings, setShowSettings] = useState(false);
  const qrRef = useRef<HTMLDivElement>(null);
  const settingsRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (showSettings) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSettings]);

  if (!purchaseURL) return null;

  const handleClickOutside = (event: MouseEvent) => {
    if (
      settingsRef.current &&
      !settingsRef.current.contains(event.target as Node)
    ) {
      setShowSettings(false);
    }
  };

  const convertSVGToCanvas = (
    callback: (canvas: HTMLCanvasElement) => void
  ) => {
    const svgElement = qrRef.current?.querySelector("svg");
    if (!svgElement) return;

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const canvas = document.createElement("canvas");
    canvas.width = size; // Ensure it is 512
    canvas.height = size;
    const ctx = canvas.getContext("2d");

    if (ctx) {
      const v = Canvg.fromString(ctx, svgData);
      v.start();

      const img = new Image();
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0, size, size);
        callback(canvas);
      };
      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    }
  };

  const handleDownload = () => {
    if (!qrRef.current) return;
    const handleSVGDownload = () => {
      if (!qrRef.current) return;

      const svgElement = qrRef.current.querySelector("svg");
      if (!svgElement) return;

      // Clone the SVG to prevent modifying the original
      const clonedSvg = svgElement.cloneNode(true) as SVGElement;

      // Ensure XML namespace is present
      clonedSvg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

      // Set correct dimensions
      const originalViewBox =
        clonedSvg.getAttribute("viewBox") ||
        `0 0 ${svgElement.clientWidth} ${svgElement.clientHeight}`;

      clonedSvg.setAttribute("viewBox", originalViewBox);
      clonedSvg.setAttribute("width", `${size}`);
      clonedSvg.setAttribute("height", `${size}`);

      // Serialize the SVG content
      const svgData = new XMLSerializer().serializeToString(clonedSvg);
      const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });

      // Trigger file download
      saveAs(blob, "qr-code.svg");
    };

    if (fileType === "eps") {
      convertSVGToCanvas((canvas) => {
        canvas.toBlob((blob) => {
          if (blob) {
            saveAs(blob, "qr-code.eps");
          }
        }, "image/png");
      });
      return;
    }

    html2canvas(qrRef.current, {
      backgroundColor: "#fff",
      scale: size / qrRef.current.clientWidth, // Ensure exact scaling
      useCORS: true, // Handle cross-origin images if needed
    }).then((canvas) => {
      const finalCanvas = document.createElement("canvas");
      finalCanvas.width = size;
      finalCanvas.height = size;
      const ctx = finalCanvas.getContext("2d");

      if (ctx) {
        ctx.fillStyle = "#fff"; // Ensure white background
        ctx.fillRect(0, 0, size, size);
        ctx.drawImage(canvas, 0, 0, size, size);
      }

      const imageData = finalCanvas.toDataURL(`image/${fileType}`);

      if (fileType === "pdf") {
        const pdf = new jsPDF({
          unit: "px",
          format: [size, size],
        });
        pdf.addImage(imageData, "PNG", 0, 0, size, size);
        pdf.save("qr-code.pdf");
      } else {
        const link = document.createElement("a");
        link.href = imageData;
        link.download = `qr-code.${fileType}`;
        link.click();
      }
    });
  };

  const toggleSettings = () => {
    setShowSettings((prev) => !prev);
  };

  const singleSelect = (
    selectedKey: string,
    className: string,
    options: IOption[],
    onChange: (value: string) => void
  ): React.ReactNode => {
    return (
      <SingleSelect
        selectedKey={selectedKey}
        searchable={false}
        nameKeys={["label"]}
        valueKeys={["value"]}
        options={[options]}
        onChange={(option: any) => onChange(option.value)}
        className={`dpdn-no-separator qr-dpdn ${className}`}
      />
    );
  };

  const renderSharingContent = (label: string): ReactNode => {
    switch (label) {
      case "Link":
        return linkContent();
      case "QR Code":
        return (
          <QRCustomWrapper>
            <FlexContainer alignItems="center" spacing={40}>
              <QRWrapper ref={qrRef}>
                <QRCode
                  value={purchaseURL}
                  size={120}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  viewBox={`0 0 120 120`}
                />
              </QRWrapper>

              <div>
                <FlexContainer alignItems="center" spacing={10}>
                  <div className="position-relative">
                    <img
                      src={DownloadIcon}
                      onClick={() => toggleSettings()}
                      className="download-qr-icon"
                    />{" "}
                    {showSettings && (
                      <SettingsPanel ref={settingsRef}>
                        <div>
                          <FlexContainer
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <label className="qr-labels">Size (px):</label>
                            {singleSelect(
                              size.toString(),
                              "",
                              sizeOptions,
                              (val) => setSize(Number(val))
                            )}
                          </FlexContainer>
                        </div>
                        <div>
                          <FlexContainer
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <label className="qr-labels">
                              Error Correction:
                            </label>
                            {singleSelect(
                              errorCorrection,
                              "",
                              errorCorrectionOptions,
                              setErrorCorrection
                            )}
                          </FlexContainer>
                        </div>
                        <div>
                          <FlexContainer
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <label className="qr-labels">File Type:</label>
                            {/* <Select
                              value={fileType}
                              onChange={(e) => setFileType(e.target.value)}
                            >
                              <option value="png">PNG</option>
                              <option value="svg">SVG</option>
                              <option value="jpg">JPG</option>
                              <option value="pdf">PDF</option>
                            </Select> */}
                            {singleSelect(
                              fileType,
                              "",
                              fileTypeOptions,
                              setFileType
                            )}
                          </FlexContainer>
                        </div>

                        <DownloadButton onClick={handleDownload}>
                          Download
                        </DownloadButton>
                      </SettingsPanel>
                    )}
                  </div>
                </FlexContainer>
              </div>
            </FlexContainer>
          </QRCustomWrapper>
        );
      default:
        return null;
    }
  };

  const handleCopyClick = (url: string) => {
    const fullURL = url;
    navigator.clipboard
      .writeText(fullURL)
      .then(() => {
        ToastService.showSuccess("Link copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy text: ", err);
      });
  };

  const handleOpenClick = () => {
    window.open(purchaseURL, "_blank");
  };

  const linkContent = () => {
    //   if (!detailPage) return null;
    //   const { isLinkEditing, linkDomain, linkPath } = detailPage;

    return (
      <FlexContainer>
        {
          //   isLinkEditing ? (
          //     <FlexContainer alignItems="center" spacing={13}>
          //       <SingleSelect
          //         hasError={false}
          //         selectedKey={linkDomain}
          //         nameKeys={["label"]}
          //         valueKeys={["value"]}
          //         options={[linkDomainOptions]}
          //         onChange={(option) =>
          //           handleInputChange("linkDomain", option.value)
          //         }
          //         className="after-pay-select"
          //       />
          //       <CustomLabel>/3012/</CustomLabel>
          //       <Input
          //         type={"text"}
          //         value={linkPath === "" ? name : linkPath}
          //         onChange={(e) => handleInputChange("linkPath", e.target.value)}
          //         placeholder="Select"
          //         className="styled-input link-input"
          //       />
          //       <img
          //         src={TickIcon}
          //         alt="Confirm"
          //         onClick={() => handleInputChange("isLinkEditing", false)}
          //         className="link-tick-icon"
          //       />
          //       {/* <img src={CrossIcon} alt="Cancel" onClick={handleCancelClick} className="link-cross-icon" /> */}
          //     </FlexContainer>
          //   )
          //   : (
          <FlexContainer alignItems="center">
            <a
              //   href={`/app/purchase/${isCheckout ? "checkout" : "purchase-link"}/${id}`}
              href={purchaseURL}
              target="_blank"
              className="link-text detail-link"
              rel="noreferrer"
            >
              {purchaseURL}
            </a>
            <img
              src={CopyIcon}
              alt="copy"
              style={{ cursor: "pointer", marginLeft: "10px" }}
              onClick={() => handleCopyClick(purchaseURL)}
            />
            <img
              src={ShareIcon}
              alt="share"
              style={{ cursor: "pointer", marginLeft: "10px" }}
              onClick={handleOpenClick}
            />

            {/* <img
                              src={EditIcon}
                              alt="Edit"
                              style={{ cursor: 'pointer', marginLeft: '10px' }}
                              onClick={handleEditClick}
                          /> */}
          </FlexContainer>
          //   )
        }
      </FlexContainer>
    );
  };

  return (
    <FlexContainer fxLayout="column">
      <CustomLabel className="pl-sub-header" margin="20px 0px 30px !important">
        Sharing
      </CustomLabel>
      <FlexContainer alignItems="center" spacing={40} className="clickable">
        {sharingOptions.map((option, index) => {
          const isActive = selectedTab === option.label;
          return (
            <SharingOptions
              key={index}
              active={isActive}
              onClick={() => setSelectedTab(option.label)}
            >
              <img
                src={isActive ? option.activeIcon : option.icon}
                alt={option.label}
              />
              <CustomLabel>{option.label}</CustomLabel>
            </SharingOptions>
          );
        })}
      </FlexContainer>

      <div className="sharing-selected-option">
        {renderSharingContent(selectedTab)}
      </div>
    </FlexContainer>
  );
};

export default SharingSection;
